/***
*
*   RUNTIME CONFIG
*   One image serves legacy and every core cell (CORE-4854). In a cell the
*   server puts window.__MC_CONFIG__ = { remote_server, remote_client,
*   disabled_features, auth } into index.html: it wins over the build-time
*   settings.json, and Mission Control's own API is then called same-origin.
*   Without it (legacy, local dev) settings.json applies exactly as before.
*
**********/

import Settings from 'settings.json';

export function clientConfig(runtime = window.__MC_CONFIG__){

  const build = Settings[process.env.NODE_ENV] || {};

  if (!runtime)
    return { ...build, injected: false, disabled_features: [], auth: 'password' };

  return {
    server_url: '', // same origin: never the localhost fallback
    remote_server: runtime.remote_server || build.remote_server,
    remote_client: runtime.remote_client || build.remote_client,
    injected: true,
    disabled_features: Array.isArray(runtime.disabled_features) ? runtime.disabled_features : [],
    auth: runtime.auth || 'password',
  };
}

// Axios base URL. '' is a cell's same origin: only a missing build-time
// server_url means local dev
export function apiBaseUrl(){

  return clientConfig().server_url ?? 'http://localhost:5001';

}

// CORE-4859: in a cell the ALB signs staff in with Microsoft (Entra) and
// Mission Control reads the forwarded token; legacy keeps the password form
export function entraAuth(){

  return clientConfig().auth === 'entra';

}

// stripe, intercom, impersonation (server: helper/features.js)
export function featureEnabled(name){

  return !clientConfig().disabled_features.includes(name);

}

// the Inbox is Intercom: without it, land on Accounts
export function defaultRoute(){

  return featureEnabled('intercom') ? '/support' : '/accounts';

}

// routes tagged with a disabled feature are not registered at all
export function enabledRoutes(routes){

  return routes.filter((route) => !route.feature || featureEnabled(route.feature));

}
